import api from './api';

const authService = {
  // Login
  login: async (email, password) => {
    try {
      const response = await api.post('/auth/login', { email, password });
      console.log('authService.login response:', response.data);
      return response.data;
    } catch (error) {
      console.error('authService.login error:', error);
      throw error;
    }
  },

  // Register
  register: async (username, email, password) => {
    try {
      const response = await api.post('/auth/register', {
        username,
        email,
        password
      });
      console.log('authService.register response:', response.data);
      return response.data;
    } catch (error) {
      console.error('authService.register error:', error);
      throw error;
    }
  },

  // Logout
  logout: async () => {
    try {
      const response = await api.post('/auth/logout');
      console.log('authService.logout response:', response.data);
      return response.data;
    } catch (error) {
      console.error('authService.logout error:', error);
      // Don't throw error on logout, just log it
      return { success: false };
    }
  },

  // Get current user
  getCurrentUser: async () => {
    try {
      const response = await api.get('/auth/me');
      console.log('authService.getCurrentUser response:', response.data);
      return response.data;
    } catch (error) {
      console.error('authService.getCurrentUser error:', error);
      throw error;
    }
  },

  // ============================================
  // NEW: Update profile (username & email)
  // ============================================
  updateProfile: async (username, email) => {
    try {
      const response = await api.put('/auth/profile', {
        username,
        email
      });
      console.log('authService.updateProfile response:', response.data);
      return response.data;
    } catch (error) {
      console.error('authService.updateProfile error:', error);
      throw error;
    }
  },

  // ============================================
  // NEW: Change password
  // ============================================
  changePassword: async (currentPassword, newPassword) => {
    try {
      const response = await api.put('/auth/change-password', {
        currentPassword,
        newPassword
      });
      console.log('authService.changePassword response:', response.data);
      return response.data;
    } catch (error) {
      console.error('authService.changePassword error:', error);
      throw error;
    }
  }
};

export default authService;